import { createAction, props } from "@ngrx/store";
import { Languages } from "src/app/enums";
import {
  AdminControllerGetEngagementFlowsWithProgramEngagementFlowV1RequestParams,
  AdminControllerGetProgramTiersV1RequestParams,
  CouponControllerGetCouponByIdV1RequestParams,
  CouponDto,
  CustomerBoostDto,
  EngagementFlowWithProgramEngagementFlowDto,
  ExecuteCustomEarningFlowResponseDto,
  Feature,
  Program,
  ProgramControllerGetProgramIntegrationsV1RequestParams,
  ProgramIntegration,
  Tier,
  WebConfig,
} from "src/app/services/api";

export const changeSessionLanguage = createAction("@app/change-session-language", props<{ language: Languages; silent?: boolean }>());
export const changeSessionLanguageSuccess = createAction("@app/change-session-language-success", props<{ language: Languages }>());

export const getProgram = createAction("@app/get-program", props<{ programId?: string; slug?: string }>());
export const getProgramSuccess = createAction("@app/get-program-success", props<{ program: Program }>());
export const getProgramFailure = createAction("@app/get-program-failure", props<{ error: string; status: number }>());

export const getProgramIntegrations = createAction(
  "@app/get-program-integrations",
  props<ProgramControllerGetProgramIntegrationsV1RequestParams>(),
);
export const getProgramIntegrationsSuccess = createAction(
  "@app/get-program-integrations-success",
  props<{ programIntegrations: ProgramIntegration[] }>(),
);
export const getProgramIntegrationsFailure = createAction("@app/get-program-integrations-failure");

export const getFeatures = createAction("@app/get-features");
export const getFeaturesSuccess = createAction("@app/get-features-success", props<{ features: Feature[] }>());
export const getFeaturesFailure = createAction("@app/get-features-failure");

export const setSessionId = createAction("@app/set-session-id", props<{ sessionId: string }>());

export const getCoupon = createAction("@app/get-coupon", props<CouponControllerGetCouponByIdV1RequestParams>());
export const getCouponSuccess = createAction("@app/get-coupon-success", props<{ coupon: CouponDto }>());
export const getCouponFailure = createAction("@app/get-coupon-failure", props<{ error: string }>());

export const getEngagementFlowsWithProgramEngagementFlow = createAction(
  "@app/get-engagement-flows-with-program-engagement-flow",
  props<
  AdminControllerGetEngagementFlowsWithProgramEngagementFlowV1RequestParams & {
    successCallback?: (engagementFlows: EngagementFlowWithProgramEngagementFlowDto[]) => void;
    errorCallback?: (error: string) => void;
  }
  >(),
);
export const getEngagementFlowsWithProgramEngagementFlowSuccess = createAction(
  "@app/get-engagement-flows-with-program-engagement-flow-success",
  props<{
    engagementFlows: EngagementFlowWithProgramEngagementFlowDto[];
    successCallback: (engagementFlows: EngagementFlowWithProgramEngagementFlowDto[]) => void;
  }>(),
);
export const getEngagementFlowsWithProgramEngagementFlowFailure = createAction(
  "@app/get-engagement-flows-with-program-engagement-flow-failure",
  props<{
    error: string;
    errorCallback: (error: string) => void;
  }>(),
);

export const previewWebConfig = createAction("@app/preview-web-config", props<{ webConfig: Partial<WebConfig> }>());

export const resetError = createAction("@app/reset-error");

export const getTiers = createAction("@app/get-tiers", props<AdminControllerGetProgramTiersV1RequestParams>());
export const getTiersSuccess = createAction("@app/get-tiers-success", props<{ tiers: Tier[] }>());
export const getTiersFailure = createAction("@app/get-tiers-failure");

export const getBoosts = createAction("@app/get-boosts");
export const getBoostsSuccess = createAction("@app/get-boosts-success", props<{ boosts: CustomerBoostDto[] }>());
export const getBoostsFailure = createAction("@app/get-boosts-failure");

export const executeCustomEarningFlow = createAction(
  "@app/execute-custom-earning-flow",
  props<{
    programId: string;
    engagementFlowName: EngagementFlowWithProgramEngagementFlowDto.NameEnum;
  }>(),
);
export const executeCustomEarningFlowSuccess = createAction(
  "@app/execute-custom-earning-flow-success",
  props<{
    engagementFlowName: EngagementFlowWithProgramEngagementFlowDto.NameEnum;
    response: ExecuteCustomEarningFlowResponseDto;
  }>(),
);
export const executeCustomEarningFlowFailure = createAction(
  "@app/execute-custom-earning-flow-failure",
  props<{ error: string }>(),
);
